import { createContext, useCallback, useContext, useState } from "react";
import { applyTheme, DARK_THEME, T } from "./theme";

const ThemeCtx = createContext({ isDark: true, toggle: () => {} });

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => T.bg0 === DARK_THEME.bg0);

  const toggle = useCallback(() => {
    setIsDark(prev => {
      const next = !prev;
      applyTheme(next);
      return next;
    });
  }, []);

  return (
    <ThemeCtx.Provider value={{ isDark, toggle }}>
      {children}
    </ThemeCtx.Provider>
  );
};

export const useTheme = () => useContext(ThemeCtx);
